module.exports = __webpack_public_path__ + "kudos_39.svg?41522cbc6027ce7e0d4179b68c7940d4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_39.svg
// module id = 138
// module chunks = 0